




































































































































































































































































































































import UploadMediaItem from './UploadMediaItem.vue'
import CreateMediaItemOccurences from './CreateMediaItemOccurences.vue'
import AddMediaItemOccurences from './AddMediaItemOccurences.vue'
import EditMediaItem from './EditMediaItem.vue'
import MediaLibraryTable from './MediaLibraryTable.vue'
import ZipMediaImport from './ZipMediaImport.vue'
import FileVersions from './FileVersions.vue'
import { pagination } from '@/shared/utils'

import {
  defineComponent,
  ref,
  watch,
  computed,
  inject,
  onBeforeMount,
} from '@vue/composition-api'
import {
  getMediaItems,
  // changeLatestFileVersionStatus,
  changeTextbookIssue,
  deleteMediaItems,
  getMediaItemOccurences,
} from '@/shared/api'
import {
  MediaItem,
  FileVersion,
  TextbookIssue,
  Textbook,
  ShortMediaItemOccurence,
} from '@/shared/types'
import {
  ARCHIVED,
  FOR_APPROVAL,
  PUBLISHED,
  WORK_IN_PROGRESS,
} from '@/shared/media/fileVersionStatus'
import {
  UPLOAD_MEDIA_ITEM,
  DELETE_MEDIA_ITEM,
  CREATE_MEDIA_ITEM_OCCURENCE,
  EDIT_MEDIA_ITEM,
} from '@/shared/user/permissions'
import { useStore as useUserStore } from '@/shared/state-management/userStore'
import { alertSymbol, licensesSymbol } from '@/shared/state-management/symbols'
const statusActions = [
  {
    title: 'archivieren',
    status: ARCHIVED,
  },
  {
    title: 'veröffentlichen',
    status: PUBLISHED,
  },
  {
    title: 'zur Freigabe',
    status: FOR_APPROVAL,
  },
  {
    title: 'in Arbeit',
    status: WORK_IN_PROGRESS,
  },
]
const occurenceFilterValues = {
  ONLY_WITHOUT_OCCURENCES: 'ONLY_WITHOUT_OCCURENCES',
  ONLY_WITH_OCCURENCES: 'ONLY_WITH_OCCURENCES',
  ALL: '',
}
export default defineComponent({
  name: 'MediaLibrary',
  components: {
    UploadMediaItem,
    EditMediaItem,
    FileVersions,
    MediaLibraryTable,
    CreateMediaItemOccurences,
    AddMediaItemOccurences,
    ZipMediaImport,
  },
  props: {
    draggable: Boolean,
    dragLoading: Boolean,
    textbook: Object,
    textbookIssueId: String,
    currentIssueOnly: Boolean,
    showOccurenceFilter: Boolean,
    zipImport: Boolean,
    selectedPages: Array,
    headers: Array,
    showTextbookIssueFilter: Boolean,
    showLicenseFilter: Boolean,
    showCategoryFilter: Boolean,
  },
  setup(props, context) {
    const $alert = inject(alertSymbol) as Function
    const search = ref(undefined)
    const selectedMediaItems = ref([])
    const sortBy = ref(['filename'])
    const sortDesc = ref(false)
    const occurenceFilter = ref([occurenceFilterValues.ALL] as Array<
      number | string
    >)
    const addMediaItemOccurencesDialogOpen = ref(false)
    const zipMediaImportDialogOpen = ref(false)
    const addOccurencesItems = ref([])
    const availableLicenses = inject(licensesSymbol) as {
      value: Array<{ id: string; name: string }>
    }
    const textbookIssueFilterOptions = computed(() =>
      [
        {
          label: context.root.$t('mediaItem.textbookIssueFilter.all'),
          value: '',
        },
        {
          label: context.root.$t('mediaItem.textbookIssueFilter.noOccurence'),
          value: 'noOccurence',
        },
      ].concat(
        (props.textbook as Textbook).issues.map((el) => ({
          value: el.id,
          label: `${el.isbn.slice(4)} - ${el.name}`,
        }))
      )
    )
    const categoryFilterOptions = computed(() =>
      [
        {
          label: context.root.$t('mediaItem.categoryFilter.all'),
          value: '',
        },
        {
          label: context.root.$t('mediaItem.categoryFilter.noCategory'),
          value: 'noCategory',
        },
      ].concat(
        (props.textbook as Textbook).categories.map((el) => ({
          value: el.id,
          label: el.name,
        }))
      )
    )
    const licenseFilterOptions = computed(() =>
      [
        {
          label: context.root.$t('mediaItem.licenseFilter.all'),
          value: '',
        },
        {
          label: context.root.$t('mediaItem.licenseFilter.noLicense'),
          value: 'noLicense',
        },
      ].concat(
        availableLicenses.value.map((el) => ({
          value: el.id,
          label: el.name,
        }))
      )
    )

    const typeFilterOptions = computed(() => [
      {
        label: context.root.$t('mediaItem.type.all'),
        value: '',
      },
      {
        label: context.root.$t('mediaItem.type.none'),
        value: 'none',
      },
      {
        label: context.root.$t('mediaItem.type.audio'),
        value: 'audio',
      },
      {
        label: context.root.$t('mediaItem.type.video'),
        value: 'video',
      },
      {
        label: context.root.$t('mediaItem.type.pdf'),
        value: 'pdf',
      },
      {
        label: context.root.$t('mediaItem.type.pdf'),
        value: 'pdf',
      },
      {
        label: context.root.$t('mediaItem.type.image'),
        value: 'image',
      },
      {
        label: context.root.$t('mediaItem.type.excel'),
        value: 'excel',
      },
      {
        label: context.root.$t('mediaItem.type.word'),
        value: 'word',
      },
      {
        label: context.root.$t('mediaItem.type.zip'),
        value: 'zip',
      },
      {
        label: context.root.$t('mediaItem.type.link'),
        value: 'link',
      },
      {
        label: context.root.$t('mediaItem.type.other'),
        value: 'other',
      },
    ])

    const { hasPermissionTo } = useUserStore().getters

    const mediaItems = ref([] as Array<MediaItem>)
    const loading = ref(false)
    const createDialogOpen = ref(false)
    const createDialogOpenHandler = () => {
      createDialogOpen.value = true
    }

    const dataTable = ref(null)
    const editDialogOpen = ref(false)
    const selectedMediaItem = ref(null)
    const fileVersionsMediaItem = ref(null)
    const fileVersionsDialogOpen = ref(null)
    const total = ref(0)
    const page = ref(1)
    const itemsPerPage = ref(pagination.default)
    const typeFilter = ref('')
    const licenseFilter = ref('')
    const textbookIssueFilter = ref('')
    const categoryFilter = ref('')

    const textbookIssue = computed((): TextbookIssue | null => {
      if (!props.textbook) {
        return null
      }
      const issue = (props.textbook.issues as Array<TextbookIssue>)
        .filter((issue: TextbookIssue) => issue.id === props.textbookIssueId)
        .pop()
      return issue || null
    })

    const textbookIssueIdFilterValue = computed(() => {
      if (props.showTextbookIssueFilter) {
        return textbookIssueFilter.value
      }
      return props.textbookIssueId &&
        (props.currentIssueOnly ||
          (occurenceFilter.value.length && occurenceFilter.value[0] !== ''))
        ? props.textbookIssueId
        : ''
    })

    const occurenceFilterOptions = computed(() => {
      if (!textbookIssue.value) {
        return
      }
      const staticOptions = [
        {
          label: context.root.$t('mediaItem.occurenceFilter.all'),
          value: occurenceFilterValues.ALL,
        },
        {
          label: context.root.$t(
            'mediaItem.occurenceFilter.onlyWithOccurences'
          ),
          value: 'onlyWithOccurences',
        },
        {
          label: context.root.$t(
            'mediaItem.occurenceFilter.onlyWithoutOccurences'
          ),
          value: occurenceFilterValues.ONLY_WITHOUT_OCCURENCES,
        },
      ]
      const pageOptions = new Array(textbookIssue.value.numberOfPages)
        .fill(null)
        .map((_el, index) => ({ label: index + 1, value: index + 1 }))
      return [...staticOptions, ...pageOptions]
    })

    const editItem = (item: MappedMediaItem) => {
      selectedMediaItem.value = item
      editDialogOpen.value = true
    }
    const showFileVersions = (item: MappedMediaItem) => {
      fileVersionsMediaItem.value = item
      fileVersionsDialogOpen.value = true
    }

    interface MappedMediaItem extends MediaItem {
      file: FileVersion | null
      textbookIssueName: string
      pages: Array<number>
    }
    const mapMediaItem = (mediaItem: MediaItem): MappedMediaItem => {
      let updatedOn = mediaItem.updatedOn
      const occurencesInIssue = mediaItem.occurences.filter(
        (occurence: ShortMediaItemOccurence) =>
          occurence.textbookIssueId === (props.textbookIssueId as string)
      )
      if (props.textbookIssueId) {
        const maxUpdatedOn = occurencesInIssue.reduce(
          (acc: number, el) => (el.updatedOn > acc ? el.updatedOn : acc),
          0
        )
        updatedOn = Math.max(updatedOn, maxUpdatedOn)
      }
      return {
        ...mediaItem,
        updatedOn,
        textbookIssueName: mediaItem.textbookIssue
          ? mediaItem.textbookIssue.name
          : '',
        file:
          mediaItem.fileVersions.length > 0 ? mediaItem.fileVersions[0] : null,
        pages: occurencesInIssue
          .reduce(
            (
              pages: Array<number>,
              occurence: ShortMediaItemOccurence
            ): Array<number> => [...pages, occurence.page],
            [] as Array<number>
          )
          .sort((a: number, b: number) => (a < b ? -1 : 1)),
      }
    }

    const preparedMediaItems = computed(() =>
      mediaItems.value.map(mapMediaItem)
    )

    const onMediaItemEdited = (newMediaItem: MediaItem) => {
      editDialogOpen.value = false
      mediaItems.value = mediaItems.value.map((mediaItem: MediaItem) =>
        mediaItem.id === newMediaItem.id ? newMediaItem : mediaItem
      )
      selectedMediaItem.value = newMediaItem
      $alert({ text: context.root.$t('mediaItem.edited'), type: 'success' })
    }

    const refreshMediaItems = async () => {
      if (loading.value || !(props.textbook && props.textbook.id)) {
        return
      }

      const queryPage = page.value
      const queryLimit = itemsPerPage.value

      loading.value = true
      const filters = {
        textbookIssues: textbookIssueIdFilterValue.value,
        categories: categoryFilter.value,
        search: search.value ?? '',
        type: typeFilter.value ?? '',
        licenses:
          props.showLicenseFilter && licenseFilter.value
            ? [licenseFilter.value]
            : '',
        onlyWithoutOccurences:
          occurenceFilter.value.length === 1 &&
          occurenceFilter.value[0] ===
            occurenceFilterValues.ONLY_WITHOUT_OCCURENCES
            ? '1'
            : '',
        textbookIssuePages:
          occurenceFilter.value.length &&
          Number.isInteger(occurenceFilter.value[0])
            ? occurenceFilter.value
            : '',
      }

      try {
        context.emit('refresh')
        const result = await getMediaItems(
          props.textbook.id,
          filters,
          queryLimit,
          queryPage,
          sortBy.value[0],
          sortDesc.value
        )
        const newMediaItems = result.results
        total.value = result.total
        // mediaItems.value = newMediaItems.map((el: MediaItem) =>
        //   mapMediaItem(el)
        // )
        mediaItems.value = [...newMediaItems]
        selectedMediaItems.value = []
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    watch(sortBy, refreshMediaItems)
    watch(sortDesc, refreshMediaItems)
    watch(
      () => props.selectedPages as Array<number>,
      (newVal: Array<number>) => {
        if (newVal.length) {
          occurenceFilter.value = [...newVal]
          refreshMediaItems()
          return
        }
        if (
          occurenceFilter.value.length &&
          Number.isInteger(occurenceFilter.value[0])
        ) {
          occurenceFilter.value = [occurenceFilterValues.ALL]
          refreshMediaItems()
        }
      }
    )

    const occurenceFilterChangedHandler = (value: Array<number | string>) => {
      page.value = 1
      if (!value || value.length === 0) {
        occurenceFilter.value = [occurenceFilterValues.ALL]
        if (props.selectedPages && props.selectedPages.length) {
          context.emit('update:selected-pages', [])
        }
        refreshMediaItems()
        return
      }
      if (value.length > occurenceFilter.value.length) {
        const addedValue = [...value, ...occurenceFilter.value]
          .filter(
            (val: number | string) => !occurenceFilter.value.includes(val)
          )
          .pop()
        if (Number.isInteger(addedValue)) {
          occurenceFilter.value = [
            ...occurenceFilter.value.filter((val: number | string) =>
              Number.isInteger(val)
            ),
            addedValue,
          ].sort((a: string | number, b: string | number) => (a < b ? -1 : 1))
          context.emit('update:selected-pages', occurenceFilter.value)
          refreshMediaItems()
          return
        }
        occurenceFilter.value = [addedValue]
        if (props.selectedPages && props.selectedPages.length) {
          context.emit('update:selected-pages', [])
        }
        refreshMediaItems()
        return
      }
      occurenceFilter.value = [
        ...value,
      ].sort((a: string | number, b: string | number) => (a < b ? -1 : 1))
      const newSelectedPages = occurenceFilter.value
        .filter((value: string | number) => Number.isInteger(value))
        .sort((a: string | number, b: string | number) => (a < b ? -1 : 1))
      if (
        props.selectedPages &&
        props.selectedPages.length !== newSelectedPages.length
      ) {
        context.emit('update:selected-pages', newSelectedPages)
      }
      refreshMediaItems()
    }

    const onMediaItemsUploaded = () => {
      createDialogOpen.value = false
      refreshMediaItems()
    }

    const onMediaItemOccurencesCreated = () => {
      createDialogOpen.value = false
      refreshMediaItems()
    }

    const deleteItems = async (mediaItemIds: Array<string>) => {
      loading.value = true
      try {
        const occurences = await getMediaItemOccurences(mediaItemIds)
        loading.value = false
        if (occurences.length) {
          const mediaItemNamesWithOccurences = occurences
            .map((el) => el.filename)
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(', ')
          await $alert({
            type: 'confirm',
            text: context.root.$t(
              'mediaItem.confirmDeleteSelectedWithOccurences',
              { mediaElements: mediaItemNamesWithOccurences }
            ),
          })
        }
        loading.value = true
        await deleteMediaItems(mediaItemIds)
        loading.value = false
        await refreshMediaItems()
        selectedMediaItems.value = []
        $alert({
          type: 'success',
          text: context.root.$t('mediaItem.deleteSelectedSuccess'),
        })
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    const deleteSelected = async () => {
      await $alert({
        type: 'confirm',
        text: context.root.$t('mediaItem.confirmDeleteSelected'),
      })
      const mediaItemIds = selectedMediaItems.value.map(
        (mediaItem) => mediaItem.id
      )
      await deleteItems(mediaItemIds)
      selectedMediaItems.value = []
    }

    const deleteMediaItem = async (mediaItem: MappedMediaItem) => {
      await $alert({
        type: 'confirm',
        text: context.root.$t('mediaItem.confirmDeleteMediaItem', {
          name: mediaItem.filename,
        }),
      })
      await deleteItems([mediaItem.id])
    }

    const changeTextbookIssueSelected = async (
      textbookIssue: TextbookIssue
    ) => {
      if (!(textbookIssue && textbookIssue.id)) {
        return
      }
      await $alert({
        type: 'confirm',
        text: context.root.$t('mediaItem.confirmChangeTextbookIssueSelected', {
          textbookIssue: textbookIssue.name,
        }),
      })
      loading.value = true
      try {
        const mediaItemIds = selectedMediaItems.value.map(
          (mediaItem) => mediaItem.id
        )
        await changeTextbookIssue(mediaItemIds, textbookIssue.id)
        loading.value = false
        await refreshMediaItems()
        $alert({
          type: 'success',
          text: context.root.$t('mediaItem.changeTextbookIssueSelectedSuccess'),
        })
        selectedMediaItems.value = []
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    const addNewMediaItemOccurences = (mediaItems: MediaItem[]) => {
      addOccurencesItems.value = [...mediaItems]
      addMediaItemOccurencesDialogOpen.value = true
    }

    const onMediaItemOccurencesAdded = (response: {
      created: Array<{ id: string }>
      deleted: Array<{ id: string }>
    }) => {
      addMediaItemOccurencesDialogOpen.value = false
      refreshMediaItems()
      $alert({
        type: 'success',
        text: context.root.$t('mediaItem.occurencesEditedSuccess'),
      })
      if (response.created.length > 0) {
        $alert({
          type: 'success',
          text: context.root.$t('mediaItem.occurencesCreatedSuccess', {
            created: response.created.length,
          }),
        })
      }
      if (response.deleted.length > 0) {
        $alert({
          type: 'success',
          text: context.root.$t('mediaItem.occurencesDeletedSuccess', {
            deleted: response.deleted.length,
          }),
        })
      }
    }

    const onMediaImported = () => {
      zipMediaImportDialogOpen.value = false
      refreshMediaItems()
    }

    onBeforeMount(() => {
      if (props.selectedPages && props.selectedPages.length) {
        occurenceFilter.value = [
          ...(props.selectedPages as Array<number | string>),
        ]
      }
      refreshMediaItems()
    })

    return {
      search,
      preparedMediaItems,
      createDialogOpen,
      createDialogOpenHandler,
      loading,
      textbookIssue,
      dataTable,
      selectedMediaItem,
      showFileVersions,
      fileVersionsDialogOpen,
      fileVersionsMediaItem,
      editDialogOpen,
      editItem,
      onMediaItemEdited,
      refreshMediaItems,
      onMediaItemsUploaded,
      selectedMediaItems,
      statusActions,
      deleteSelected,
      // changeStatusSelected,
      changeTextbookIssueSelected,
      deleteMediaItem,
      total,
      page,
      itemsPerPage,
      hasPermissionTo,
      UPLOAD_MEDIA_ITEM,
      EDIT_MEDIA_ITEM,
      CREATE_MEDIA_ITEM_OCCURENCE,
      DELETE_MEDIA_ITEM,
      sortBy,
      sortDesc,
      typeFilter,
      typeFilterOptions,
      onMediaItemOccurencesCreated,
      occurenceFilterOptions,
      occurenceFilter,
      addNewMediaItemOccurences,
      addMediaItemOccurencesDialogOpen,
      addOccurencesItems,
      onMediaItemOccurencesAdded,
      zipMediaImportDialogOpen,
      onMediaImported,
      occurenceFilterChangedHandler,
      textbookIssueFilter,
      textbookIssueFilterOptions,
      categoryFilter,
      categoryFilterOptions,
      licenseFilter,
      licenseFilterOptions,
      textbookIssueIdFilterValue,
    }
  },
})
